/** @jsx jsx */
import { FC } from "react";
import { jsx } from "theme-ui";

import { ResponsiveCard } from "@/components/ResponsiveCard";
import { TimeReport, useTimeReportAggregate } from "@/data/time-reports";
import { TimeReportSpecification, TimeReportSpecificationEmptyState } from "@/views/time-reports/specification";

interface TimeReportDetailsSpecificationTabProps {
  timeReport: TimeReport;
}

export const TimeReportDetailsSpecificationTab: FC<TimeReportDetailsSpecificationTabProps> = ({ timeReport }) => {
  const specificationAggregateData = useTimeReportAggregate(timeReport, {
    from: new Date(timeReport.startDate),
    to: new Date(timeReport.endDate),
    filterEmptyItems: true,
  });

  if (specificationAggregateData.aggregateTotalReportedTime.isEmpty) {
    return <TimeReportSpecificationEmptyState />;
  }

  return (
    <ResponsiveCard sx={{ py: ["sm", "sm", "sm", "md"] }}>
      <TimeReportSpecification timeReport={timeReport} aggregateData={specificationAggregateData} />
    </ResponsiveCard>
  );
};
